module.exports = __webpack_public_path__ + "img/pr-5.d3623d5a.png";